var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-view-select", class: _vm.selectClass },
    [
      _c(
        "el-select",
        {
          ref: "select",
          staticStyle: { width: "100%" },
          attrs: {
            "popper-class": "view-select-option",
            multiple: "",
            clearable: "",
          },
          on: {
            "remove-tag": _vm._selectRemoveTag,
            clear: _vm._selectClearFun,
            focus: _vm._popoverShowFun,
          },
          model: {
            value: _vm.innerValues,
            callback: function ($$v) {
              _vm.innerValues = $$v
            },
            expression: "innerValues",
          },
        },
        _vm._l(_vm.selectOptions, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: { label: item.name, value: item.id },
          })
        }),
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-css",
          attrs: {
            visible: _vm.dialogShow,
            "show-close": false,
            fullscreen: true,
          },
        },
        [
          _vm.dialogShow && _vm.viewLoaded
            ? _c(
                "div",
                {
                  ref: "contaninerDiv",
                  style: { height: _vm.panelHeight + "px" },
                },
                [
                  _c("Preview", {
                    attrs: {
                      "component-data": _vm.mainCanvasComponentData,
                      "canvas-style-data": _vm.canvasStyleData,
                      "panel-info": _vm.panelInfo,
                      "show-position": _vm.showPosition,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer title-text",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("span", { staticStyle: { "font-size": "14px" } }, [
                _vm._v("\n        选择视图\n      "),
              ]),
              _c(
                "span",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.sureDialog()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("commons.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.cancelDialog()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("commons.cancel")))]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }